import { render, staticRenderFns } from "./Page8.vue?vue&type=template&id=dac4abdc&scoped=true&"
import script from "./Page8.vue?vue&type=script&lang=js&"
export * from "./Page8.vue?vue&type=script&lang=js&"
import style0 from "./Page8.vue?vue&type=style&index=0&id=dac4abdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac4abdc",
  null
  
)

export default component.exports